import React from "react";
import { useLang } from "@/contexts/LanguageContext";

export default function LanguageSwitcher({ variant = "header" }) {
  const { lang, setLang, languages } = useLang();
  return (
    <div
      data-testid="lang-switcher"
      className="inline-flex items-center gap-1 rounded-full pfi-gold-border px-1 py-1 bg-black/40"
    >
      {languages.map((l) => {
        const active = lang === l.code;
        return (
          <button
            key={l.code}
            data-testid={`lang-switcher-${l.code}`}
            onClick={() => setLang(l.code)}
            className={
              "px-3 py-1 text-xs font-mono tracking-widest rounded-full transition-colors " +
              (active
                ? "bg-[#d4af37] text-[#0a0a0c]"
                : "text-[#a9a9b8] hover:text-[#e6c687]")
            }
            aria-pressed={active}
          >
            {l.short}
          </button>
        );
      })}
    </div>
  );
}
